/** @jsx React.DOM */
'use strict';

var React = require('react'),
    ItemTypes = require('./ItemTypes'),
    $__0=    React,PropTypes=$__0.PropTypes,
    $__1=    require('react-dnd'),DragDropMixin=$__1.DragDropMixin;

var Item = React.createClass({displayName: 'Item',
  mixins: [DragDropMixin],

  propTypes: {
    name: PropTypes.string.isRequired
  },

  configureDragDrop:function(registerType) {
    registerType(ItemTypes.ITEM, {
      dragSource: {
        beginDrag:function() {
          return {
            item: {
              name: this.props.name
            }
          };
        }
      }
    });
  },

  render:function() {
    var $__0=    this.getDragState(ItemTypes.ITEM),isDragging=$__0.isDragging;

    return (
      React.createElement("div", React.__spread({},  this.dragSourceFor(ItemTypes.ITEM), 
           {style: {
             border: '1px dashed gray',
             backgroundColor: 'white',
             padding: '0.5rem',
             margin: '0.5rem',
             opacity: isDragging ? 0.4 : 1,
             maxWidth: 80
           }}), 
        this.props.name
      )
    );
  }
});

module.exports = Item;


/*****************
 ** WEBPACK FOOTER
 ** ./_dustbin-simple/Item.js
 ** module id = 145
 ** module chunks = 0
 **/